import { getSkillsListQueryOptions, getStafferGigsV2ListWithTransformQueryOptions } from "@sidegigllc/api/client";
import { marketsQueryOptions } from "api/queries/markets";
import { selectStafferGigs } from "api/queries/stafferGigs";
import { queries as gigInfoSidebarQueries } from "domains/gigs/containers/GigInfoSidebar/queries";
import type { gigs } from "routing/tree/admin";
import type { WarmableQuery } from "routing/warmQueries";

type GigsSearch = Omit<ReturnType<typeof gigs.useSearch>, "expanded_gig_ids" | "applicationParams">;
type GigListSearch = Omit<GigsSearch, "selected_gig_id" | "selected_pro_id">;

export const gigsQuery = ({ search }: { search: GigListSearch }) =>
  getStafferGigsV2ListWithTransformQueryOptions(
    {
      ...search,
      types: search.type ? [search.type] : undefined,
      statuses: search.status ? [search.status] : undefined,
      employment_types: search.employment_type ? [search.employment_type] : undefined,
      skill_id: search.skill_id != null ? [search.skill_id] : undefined,
    },
    { query: { select: selectStafferGigs } },
  );

export const skillsQuery = () => getSkillsListQueryOptions({ query: "ordered_by_popularity" });

export const queries = ({ search }: { search: GigsSearch }): Array<WarmableQuery> => {
  const { selected_gig_id, selected_pro_id, ...listSearch } = search;
  return [
    gigsQuery({ search: listSearch }),
    marketsQueryOptions(),
    skillsQuery(),
    ...gigInfoSidebarQueries({ search: { selected_gig_id, selected_pro_id } }),
  ];
};
